import { AxiosInstance } from 'axios';
import { APP_CONFIG } from '../../constants/APP_CONFIG';

// See /setupTests for usage
declare let __TEST_REQUEST_COUNT__: number;

/**
 * Deny real API calls from inside a unit test
 */
export const preventRealRequestsInTests = (client: AxiosInstance) => {
  if (APP_CONFIG.build.environment === 'test') {
    client.interceptors.request.use(config => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      __TEST_REQUEST_COUNT__++;
      const error = new Error(
        `A test attempted to make an HTTP request to: ${config.method?.toUpperCase()} ${
          config.url
        }\nPlease mock your API requests for unit tests.`
      );
      // eslint-disable-next-line no-console
      console.error(error); // Display so the developer can see it in the test output
      throw error;
    });
  }
};
